
import store from '@/store';
import { defineComponent } from 'vue';
import { SystemSettingsModel } from '@/interfaces/panel/system-settings.model';
import CustomButton from '@/components/vuetifyComponents/CustomButton.vue';

export default defineComponent({
    name: "UsersListPage",

    components: { CustomButton },

    data() {
        return {
            setting: {}
        }
    },

    computed: {
        getLoadingPanel(): boolean {
            return store.getters["panel/getLoadingPanel"];
        },
        getSystemSettings(): SystemSettingsModel {
            return store.getters["panel/getSystemSettings"];
        }
    },

    methods: {
        submitSettingsFilter() {
            store.dispatch("panel/sendSystemEditRequest", this.getSystemSettings);
        }
    },

    mounted() {
        store.dispatch("panel/getSystemSettingRequest");
    }
})
